import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';

@Component({
  selector: 'app-select-project-modal',
  templateUrl: './select-project-modal.component.html',
  styleUrls: ['./select-project-modal.component.less'],
  standalone: false
})
export class SelectProjectModalComponent implements OnInit {
  form!: FormGroup;
  projectList: {id: number, projectTitle: string, projectName: string}[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectProjectModalComponent>,
    private readonly formBuilder: FormBuilder,
    public defaults: DefaultValuesService,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.projectList = this.data.projectList.map((p: {id: number, projectTitle: string}) => ({
      ...p,
      projectName: `${p.id} - ${p.projectTitle}`
    }));

    this.form = this.formBuilder.group({
      projectId: ['', [Validators.required]],
    });
  }


  onSubmit(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  backButtonHandler(event: Event): void {
    event.preventDefault();
    this.dialogRef.close();
  }
}